import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { ProjectsDashboard } from '../projects/ProjectsDashboard';
import { ProjectDetail } from '../projects/ProjectDetail';
import { CreateProjectModal } from '../projects/CreateProjectModal';
import { CreatePostModal } from '../projects/CreatePostModal';
import { GET_PROJECT } from '../../graphql/queries';
import { toast } from 'sonner';
import { Toaster } from '../ui/sonner';

type View = 'dashboard' | 'project-detail';

export function ProjectsLayout() {
  const [currentView, setCurrentView] = useState<View>('dashboard');
  const [selectedProjectId, setSelectedProjectId] = useState<string | null>(null);
  const [isCreateProjectOpen, setIsCreateProjectOpen] = useState(false);
  const [isCreatePostOpen, setIsCreatePostOpen] = useState(false);

  const handleViewProject = (projectId: string) => {
    setSelectedProjectId(projectId);
    setCurrentView('project-detail');
  };

  const handleBackToDashboard = () => {
    setCurrentView('dashboard');
    setSelectedProjectId(null);
  };

  const handleCreateProject = (project: any) => {
    console.log('Creating project:', project);
    toast.success('Project created successfully!');
    // In a real app, this would save to a database
  };

  const handleCreatePost = (post: any) => {
    console.log('Creating post:', post);
    toast.success('Post created successfully!');
    // In a real app, this would save to a database
  };

  // Fetch project data when we have a selected project (for team members in create post modal)
  const { data: projectData } = useQuery(GET_PROJECT, {
    variables: { id: selectedProjectId },
    skip: !selectedProjectId,
  });

  const teamMembers = projectData?.project?.teamMembers || [];

  return (
    <div className="ink-page flex w-full flex-col h-full min-h-0 overflow-hidden">
      <div className="mx-1 flex flex-col flex-1 overflow-y-auto w-full max-w-full bg-core-dark text-cmp-ink min-h-0">
        {currentView === 'dashboard' ? (
          <ProjectsDashboard
            onCreateProject={() => setIsCreateProjectOpen(true)}
            onViewProject={handleViewProject}
          />
        ) : (
          <ProjectDetail
            projectId={selectedProjectId!}
            onBack={handleBackToDashboard}
            onCreatePost={() => setIsCreatePostOpen(true)}
          />
        )}

        <CreateProjectModal
          open={isCreateProjectOpen}
          onClose={() => setIsCreateProjectOpen(false)}
          onSubmit={handleCreateProject}
        />

        {selectedProjectId && (
          <CreatePostModal
            open={isCreatePostOpen}
            onClose={() => setIsCreatePostOpen(false)}
            projectId={selectedProjectId}
            teamMembers={teamMembers}
            onSubmit={handleCreatePost}
          />
        )}

        <Toaster />
      </div>
    </div>
  );
}
